var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Libra") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Libra",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Scale",
    fill: "#000000",
    points: "2 22 22 22 22 20 2 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2736,16 C18.9426,14.537 19.9996,12.395 19.9996,10 C19.9996,5.582 16.4186,2 11.9996,2 C7.5816,2 3.9996,5.582 3.9996,10 C3.9996,12.395 5.0576,14.537 6.7266,16 L1.9996,16 L1.9996,18 L9.9996,18 L9.9996,17.738 L9.9996,16 L9.9996,15.65 C7.6736,14.824 5.9996,12.606 5.9996,10 C5.9996,6.692 8.6916,4 11.9996,4 C15.3086,4 17.9996,6.692 17.9996,10 C17.9996,12.606 16.3266,14.824 13.9996,15.65 L13.9996,16 L13.9996,17.738 L13.9996,18 L21.9996,18 L21.9996,16 L17.2736,16 Z",
    id: "Top",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/libra.9176277a36f30fb217cbca00fdd6d1af.svg";
export { ForwardRef as ReactComponent };